import React, { useRef, useEffect } from "react";
import { Theme, makeStyles, useTheme } from "@material-ui/core/styles";
import { amber } from "@material-ui/core/colors";
import { Card, CardHeader, CardContent, Typography } from "@material-ui/core";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import _ from "lodash";
am4core.useTheme(am4themes_animated);

const useStyle = makeStyles((theme: Theme) => ({
  header: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    borderBottom: `solid 1px ${theme.palette.divider}`,
  },
  headerTitle: { fontFamily: "Montserrat-SemiBold" },
  contentFull: {
    padding: theme.spacing(0),
    "&:last-child": { paddingBottom: theme.spacing(0) },
    height: `calc(100vh - ${theme.spacing(43.5)}px)`,
    position: "relative",
  },
  pieDiv: { height: "60%" },
  lineDiv: { height: "40%" },
}));

interface UserList {
  usersData: any;
}

const UserChart = (props: UserList) => {
  const classes = useStyle();
  const theme = useTheme();
  const pieChartRef = useRef<any>(null);
  const lineChartRef = useRef<any>(null);
  const { usersData } = props;

  useEffect(() => {
    const meaUsers: any = usersData.meaUsers;
    const customerUsers: any = usersData.customerUsers;

    const DataMeauser = meaUsers.map((rs: any, index: any) => {
      return {
        date: `${new Date(rs.created_at).getDay()}/${new Date(
          rs.created_at
        ).getMonth()}/${new Date(rs.created_at).getFullYear()}`,
        detail: rs.created_at,
      };
    });

    const uniqMea = _.uniqBy(DataMeauser, "date");

    let newMEA: any[] = [];
    uniqMea.map((rs: any) => {
      const check = DataMeauser.filter((fl: any) => fl.date === rs.date);

      newMEA = [
        ...newMEA,
        {
          date: new Date(rs.detail),
          value1: check.length,
        },
      ];
      return null;
    });

    const DataCustomuser = customerUsers.map((rs: any, index: any) => {
      return {
        date: `${new Date(rs.created_at).getDay()}/${new Date(
          rs.created_at
        ).getMonth()}/${new Date(rs.created_at).getFullYear()}`,
        detail: rs.created_at,
      };
    });

    const uniqCustom = _.uniqBy(DataMeauser, "date");

    let newCustom: any[] = [];
    uniqCustom.map((rs: any) => {
      const check = DataCustomuser.filter((fl: any) => fl.date === rs.date);

      newCustom = [
        ...newCustom,
        {
          date: new Date(rs.detail),
          value2: check.length,
        },
      ];
      return null;
    });

    const UserData: any[] = [...newMEA, ...newCustom];

    am4core.createFromConfig(
      {
        series: [
          {
            type: "PieSeries",
            alignLabels: false,
            ticks: {
              disabled: true,
            },
            labels: {
              text:
                "[bold,font-size:1.5rem]{value} คน [/]\n[font-size:1.2rem]{value.percent.formatNumber('#.0')}%[/]",
              radius: "-40%",
              fill: "white",
            },
            dataFields: {
              value: "count",
              category: "userType",
            },
            slices: {
              template: {
                stroke: am4core.color("#fff"),
                strokeWidth: 1,
                tooltipText: "",
                propertyFields: {
                  fill: "color",
                },
              },
            },
          },
        ],
        data: [
          {
            userType: "MEA User",
            count: meaUsers ? meaUsers.length : 0,
            color: am4core.color(amber["500"]),
          },
          {
            userType: "Custumer",
            count: customerUsers ? customerUsers.length : 0,
            color: am4core.color(theme.palette.primary.main),
          },
        ],
      },
      pieChartRef ? pieChartRef.current : "",
      am4charts.PieChart
    );
    am4core.createFromConfig(
      {
        cursor: {
          type: "XYCursor",
        },
        xAxes: [
          {
            type: "DateAxis",
            // groupData: true,
            renderer: {
              labels: {
                fontSize: "0.75rem",
              },
            },
          },
        ],
        yAxes: [
          {
            type: "ValueAxis",
            renderer: {
              labels: {
                fontSize: "0.75rem",
              },
            },
          },
        ],
        series: [
          {
            type: "LineSeries",
            name: "MEA User",
            dataFields: {
              valueY: "value1",
              dateX: "date",
            },
            tooltipText: "[white]{dateX}: [bold&white]{valueY}",
            hoverOnFocus: true,
            strokeWidth: 2,
            stroke: am4core.color(theme.palette.primary.main),
            fillOpacity: 0.25,
            fill: am4core.color(theme.palette.primary.main),
          },
          {
            type: "LineSeries",
            name: "Customer",
            dataFields: {
              valueY: "value2",
              dateX: "date",
            },
            tooltipText: "[white]{dateX}: [bold&white]{valueY}",
            hoverOnFocus: true,
            strokeWidth: 2,
            stroke: am4core.color(amber["500"]),
            fillOpacity: 0.25,
            fill: am4core.color(amber["500"]),
          },
        ],
        legend: {
          valueLabels: {
            text: "{value.value}",
          },
        },
        data: UserData,
      },
      lineChartRef ? lineChartRef.current : "",
      am4charts.XYChart
    );
    return () => {};
  }, [pieChartRef, theme, usersData]);

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="subtitle1" className={classes.headerTitle}>
            User
          </Typography>
        }
        className={classes.header}
      />
      <CardContent className={classes.contentFull}>
        <div ref={pieChartRef} className={classes.pieDiv} />
        {/* <Divider /> */}
        <div ref={lineChartRef} className={classes.lineDiv} />
      </CardContent>
    </Card>
  );
};

export default UserChart;
